import { DataBean } from "../../DataBean";


export class StructureCatalog extends DataBean {

    public async getHealthIDStructureCatalog(idHealthIDStructure: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getHealthIDStructureCatalog_Number", [idHealthIDStructure]);
    }

}